import { useQuery } from '@tanstack/react-query'

import { optimoPrivateApi } from '@/api/axios/axiosInstance'
import { endpoints } from '@/api/endpoints'
import type { ImpersonationStatusResponse as ImpersonationStatus } from '@/api/actions/auth/authActions.types'

export function useImpersonationStatus() {
    const query = useQuery<ImpersonationStatus>({
        queryKey: ['impersonation', 'status'],
        queryFn: async () => {
            const { data } = await optimoPrivateApi.get<ImpersonationStatus>(endpoints.impersonation.status)
            return data
        },
        // Keep this lightweight and resilient
        staleTime: 5_000,
        refetchInterval: 15_000,
        refetchOnWindowFocus: true,
        retry: false,
    })

    return {
        status: query.data ?? null,
        isLoading: query.isLoading,
        refetch: query.refetch,
    }
}
